'use strict';

var index = require('../../../../../../_virtual/index2.cjs');
var cookieThemeManager = require('./cookieThemeManager.cjs');
var isLocalStorageEnabled = require('./isLocalStorageEnabled.cjs');

const getThemePreference = ()=>{
    const cookieTheme = cookieThemeManager.getThemeCookie();
    if (cookieTheme) return cookieTheme;
    const localStorageTheme = isLocalStorageEnabled.isLocalStorageEnabled() ? localStorage.getItem("aviaryTheme") : null;
    if (localStorageTheme === "dark" || localStorageTheme === "light") {
        cookieThemeManager.setThemeCookie(localStorageTheme);
        // Remove from localStorage as we don't need it anymore
        localStorage.removeItem("aviaryTheme");
        return localStorageTheme;
    }
    return null;
};
/**
 * Returns the theme based on the brand, controlled theme, and preferred color scheme
 */ const getTheme = (brand, controlledTheme, isPrefersDark, screenSize)=>{
    const themePreference = getThemePreference();
    if (brand === "emerson") return index.cjsExports.emersonWeb[screenSize];
    if (controlledTheme) return controlledTheme === "dark" ? index.cjsExports.fullscriptWebDark[screenSize] : index.cjsExports.fullscriptWebLight[screenSize];
    if (themePreference === "dark" || isPrefersDark && !themePreference) {
        return index.cjsExports.fullscriptWebDark[screenSize];
    }
    return index.cjsExports.fullscriptWebLight[screenSize];
};

exports.getTheme = getTheme;
//# sourceMappingURL=getTheme.cjs.map
